__turbopack_context__.v({
  "body": "yQkJ2q_body",
  "description": "yQkJ2q_description",
  "error": "yQkJ2q_error",
  "icon": "yQkJ2q_icon",
  "inner": "yQkJ2q_inner",
  "input": "yQkJ2q_input",
  "label": "yQkJ2q_label",
  "labelWrapper": "yQkJ2q_labelWrapper",
  "root": "yQkJ2q_root",
});
